(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6021],{

/***/ 22982:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/post_topics/LIVE",
      function () {
        return __webpack_require__(70150);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 86177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useMountedDelay; }
/* harmony export */ });
/* unused harmony export useMounted */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useMounted = function() {
    var ref = useState(false), mounted = ref[0], setMounted = ref[1];
    useEffect(function() {
        setMounted(true);
    }, []);
    return mounted;
};
var useMountedDelay = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var delay = setTimeout(function() {
            setMounted(true);
        }, 500);
        return function() {
            delay && clearTimeout(delay);
            setMounted(true);
        };
    }, []);
    return mounted;
};


/***/ }),

/***/ 32954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TimelineSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(87066);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88767);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(21190);
/* harmony import */ var components_Post__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53704);
/* harmony import */ var common_interfaces_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21694);
/* harmony import */ var store_timeline__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12800);
/* harmony import */ var store_global__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8405);
/* harmony import */ var components_common_Icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37975);
/* harmony import */ var components_common_InfiniteScroll__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68330);
/* harmony import */ var _TimelineSection_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(16081);
/* harmony import */ var _TimelineSection_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_TimelineSection_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var components_common_PreloadContentLoader__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(60782);
/* harmony import */ var common_utils_hooks_useDidMount__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86177);
















function TimelineSection(param) {
    var apiUrl = param.apiUrl, queryKey = param.queryKey, _queryParamKey = param.queryParamKey, queryParamKey = _queryParamKey === void 0 ? "last_post_id" : _queryParamKey, _getNextPageParam = param.getNextPageParam, getNextPageParam = _getNextPageParam === void 0 ? function(lastPage) {
        var ref;
        var posts = lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.data) === null || ref === void 0 ? void 0 : ref.posts;
        if (posts && posts.length > 0) {
            var lastPost = posts[posts.length - 1];
            return lastPost.id;
        }
    } : _getNextPageParam, _noResultMessage = param.noResultMessage, noResultMessage = _noResultMessage === void 0 ? "投稿はありません" : _noResultMessage, _disableInfiniteScroll = param.disableInfiniteScroll, disableInfiniteScroll = _disableInfiniteScroll === void 0 ? false : _disableInfiniteScroll, _hideNoResult = param.hideNoResult, hideNoResult = _hideNoResult === void 0 ? false : _hideNoResult, _defaultPageParam = param.defaultPageParam, defaultPageParam = _defaultPageParam === void 0 ? 0 : _defaultPageParam, subQuery = param.subQuery;
    var shouldRefetchPosts = (0,store_timeline__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(function(state) {
        return state.shouldRefetchPosts;
    });
    var isAuthInit = (0,store_global__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(state) {
        return state.isAuthInit;
    });
    var currentAuth = (0,store_global__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(state) {
        return state.currentAuth;
    });
    var mounted = (0,common_utils_hooks_useDidMount__WEBPACK_IMPORTED_MODULE_11__/* .useMountedDelay */ ._)();
    var usingMounted = currentAuth ? true : mounted;
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useInfiniteQuery)(queryKey, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var _pageParam, pageParam, query, filterParam, subQueryParam, url;
            return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? defaultPageParam : _pageParam;
                        if (!(!isAuthInit || !usingMounted)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject());
                    case 3:
                        query = "".concat(queryParamKey, "=").concat(String(pageParam));
                        filterParam = queryKey && queryKey[0] === common_interfaces_api__WEBPACK_IMPORTED_MODULE_5__/* .PostParentKey.UnReadPosts */ .rO.UnReadPosts ? "&unread=true" : "";
                        subQueryParam = subQuery ? "&".concat(subQuery.key, "=").concat(subQuery.value) : "";
                        url = "".concat(apiUrl, "?").concat(query).concat(filterParam).concat(subQueryParam);
                        _ctx.next = 9;
                        return axios__WEBPACK_IMPORTED_MODULE_13__/* ["default"].get */ .Z.get(url);
                    case 9:
                        return _ctx.abrupt("return", _ctx.sent.data);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        getNextPageParam: getNextPageParam,
        // TODO: somehow enabled is not working as intended
        // useInfiniteQuery still runs when enabled is false
        // this is currently handled by only shows this component when isAuthInit is true
        enabled: isAuthInit && usingMounted,
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 15 * 60 * 1000,
        cacheTime: 15 * 60 * 1000
    }), isLoading = ref.isLoading, data = ref.data, fetchNextPage = ref.fetchNextPage, refetch = ref.refetch, isFetchingNextPage = ref.isFetchingNextPage, isFetched = ref.isFetched;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (shouldRefetchPosts) {
            void refetch();
        }
    }, [
        shouldRefetchPosts,
        refetch
    ]);
    var pages = data === null || data === void 0 ? void 0 : data.pages;
    var posts = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return pages ? pages.reduce(function(curr, page) {
            var ref;
            var posts = ((ref = page.data) === null || ref === void 0 ? void 0 : ref.posts) || [];
            return curr.concat(posts);
        }, []) : [];
    }, [
        pages
    ]);
    var noPostPlaceholder;
    if (!isLoading && posts.length === 0 && !hideNoResult) {
        noPostPlaceholder = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: (_TimelineSection_module_scss__WEBPACK_IMPORTED_MODULE_14___default().noPost),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                    name: "empty",
                    width: 96,
                    height: 96
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: noResultMessage
                    }
                })
            ]
        });
    }
    // Animation
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), doUseAnimation = ref1[0], setUseAnimation = ref1[1];
    // Prevent animation from playing on first load
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var timeout;
        if (!isLoading) {
            timeout = setTimeout(function() {
                return setUseAnimation(true);
            });
        }
        return function() {
            clearTimeout(timeout);
            setUseAnimation(false);
        };
    }, [
        isLoading
    ]);
    if (!queryKey || !queryKey[0]) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
    var postsRender = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_15__/* .AnimatePresence */ .M, {
        initial: false,
        children: posts.map(function(post, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (_TimelineSection_module_scss__WEBPACK_IMPORTED_MODULE_14___default().post),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Post__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    post: post,
                    shouldAnimate: doUseAnimation,
                    parent: String(queryKey[0]),
                    hasFollowBtn: true,
                    isPinned: queryKey[0] === common_interfaces_api__WEBPACK_IMPORTED_MODULE_5__/* .PostParentKey.ProfilePosts */ .rO.ProfilePosts && post.is_pinned
                })
            }, "".concat(post === null || post === void 0 ? void 0 : post.id, "-").concat(index));
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (_TimelineSection_module_scss__WEBPACK_IMPORTED_MODULE_14___default().timelineWrapper),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_InfiniteScroll__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                fetchNextPage: fetchNextPage,
                disabled: disableInfiniteScroll,
                isLoading: isFetchingNextPage,
                children: isFetched ? postsRender : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_PreloadContentLoader__WEBPACK_IMPORTED_MODULE_10__/* .PostsLoader */ .DN, {})
            }),
            noPostPlaceholder
        ]
    });
};


/***/ }),

/***/ 70150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ LivePostsPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_TimelineSection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32954);
/* harmony import */ var _LivePostsPage_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80164);
/* harmony import */ var _LivePostsPage_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_LivePostsPage_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var common_interfaces_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21694);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var config_env__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36514);




// import CoinBanner from 'components/common/CoinBanner';
// import { INVITE_USER_COIN_EVENT } from 'common/utils';



var title = "リアルタイムで投資・相場情報をLIVE配信で知れる | PostPrime";
var description = "日本株や米国株、コモディティ、暗号資産やFXなど様々な情報をLIVEでお届けします。お金を楽しく学べるPostPrimeで活躍中のクリエイター達のLIVE配信では質問などができるためあなたの投資を大きく促進させます。";
var url = "".concat(config_env__WEBPACK_IMPORTED_MODULE_5__/* .SITE_BASE_URL */ .B, "/post_topics/LIVE");
var __N_SSP = true;
function LivePostsPage() {
    var getNextPageParamLivePosts = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(lastPage, pages) {
        var ref;
        var posts = lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.data) === null || ref === void 0 ? void 0 : ref.posts;
        if (posts && posts.length > 0) {
            return pages.length + 1;
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: url
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: url
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                style: {
                    display: "none"
                },
                children: "日本株・米国株・FXや暗号資産の最新情報をLIVE配信"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_LivePostsPage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().timelineSection),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_LivePostsPage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_TimelineSection__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        apiUrl: "/feeds/lives",
                        queryKey: [
                            common_interfaces_api__WEBPACK_IMPORTED_MODULE_3__/* .PostParentKey.LiveTopics */ .rO.LiveTopics
                        ],
                        queryParamKey: "page",
                        getNextPageParam: getNextPageParamLivePosts,
                        defaultPageParam: 1
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 16081:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"noPost":"TimelineSection_noPost__Oy64j","post":"TimelineSection_post__St5uN"};

/***/ }),

/***/ 80164:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"timelineSection":"LivePostsPage_timelineSection__nbNMi","content":"LivePostsPage_content__7VK_l","titleWrapper":"LivePostsPage_titleWrapper__v3xsa","title":"LivePostsPage_title__8e3OF","keyword":"LivePostsPage_keyword__VIFgX","membershipBanner":"LivePostsPage_membershipBanner__3kcJc","coinBanner":"LivePostsPage_coinBanner__byXP_"};

/***/ }),

/***/ 21190:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ AnimatePresence; }
});

// EXTERNAL MODULE: ./node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(81439);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/process.mjs
var process = __webpack_require__(49304);
// EXTERNAL MODULE: ./node_modules/framesync/dist/es/index.mjs + 2 modules
var es = __webpack_require__(54735);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.mjs
var use_isomorphic_effect = __webpack_require__(58868);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-is-mounted.mjs



function useIsMounted() {
    var isMounted = (0,react.useRef)(false);
    (0,use_isomorphic_effect/* useIsomorphicLayoutEffect */.L)(function () {
        isMounted.current = true;
        return function () {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-force-update.mjs





function useForceUpdate() {
    var isMounted = useIsMounted();
    var _a = (0,tslib_es6/* __read */.CR)((0,react.useState)(0), 2), forcedRenderCount = _a[0], setForcedRenderCount = _a[1];
    var forceRender = (0,react.useCallback)(function () {
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [forcedRenderCount]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */
    var deferredForceRender = (0,react.useCallback)(function () { return es/* default.postRender */.ZP.postRender(forceRender); }, [forceRender]);
    return [deferredForceRender, forcedRenderCount];
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/PresenceContext.mjs
var PresenceContext = __webpack_require__(240);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(96681);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-id.mjs
var use_id = __webpack_require__(76316);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/PresenceChild.mjs







var PresenceChild = function (_a) {
    var children = _a.children, initial = _a.initial, isPresent = _a.isPresent, onExitComplete = _a.onExitComplete, custom = _a.custom, presenceAffectsLayout = _a.presenceAffectsLayout;
    var presenceChildren = (0,use_constant/* useConstant */.h)(newChildrenMap);
    var id = (0,use_id/* useId */.M)();
    var context = (0,react.useMemo)(function () { return ({
        id: id,
        initial: initial,
        isPresent: isPresent,
        custom: custom,
        onExitComplete: function (childId) {
            var e_1, _a;
            presenceChildren.set(childId, true);
            try {
                for (var _b = (0,tslib_es6/* __values */.XA)(presenceChildren.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var isComplete = _c.value;
                    if (!isComplete)
                        return; // can stop searching when any is incomplete
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete();
        },
        register: function (childId) {
            presenceChildren.set(childId, false);
            return function () { return presenceChildren.delete(childId); };
        },
    }); }, 
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    presenceAffectsLayout ? undefined : [isPresent]);
    (0,react.useMemo)(function () {
        presenceChildren.forEach(function (_, key) { return presenceChildren.set(key, false); });
    }, [isPresent]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */
    react.useEffect(function () {
        !isPresent && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete());
    }, [isPresent]);
    return (react.createElement(PresenceContext/* PresenceContext.Provider */.O.Provider, { value: context }, children));
};
function newChildrenMap() {
    return new Map();
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/LayoutGroupContext.mjs
var LayoutGroupContext = __webpack_require__(25364);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-unmount-effect.mjs
var use_unmount_effect = __webpack_require__(65411);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs











var getChildKey = function (child) { return child.key || ""; };
function updateChildLookup(children, allChildren) {
    children.forEach(function (child) {
        var key = getChildKey(child);
        allChildren.set(key, child);
    });
}
function onlyElements(children) {
    var filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    react.Children.forEach(children, function (child) {
        if ((0,react.isValidElement)(child))
            filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */
var AnimatePresence = function (_a) {
    var children = _a.children, custom = _a.custom, _b = _a.initial, initial = _b === void 0 ? true : _b, onExitComplete = _a.onExitComplete, exitBeforeEnter = _a.exitBeforeEnter, _c = _a.presenceAffectsLayout, presenceAffectsLayout = _c === void 0 ? true : _c;
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    var _d = (0,tslib_es6/* __read */.CR)(useForceUpdate(), 1), forceRender = _d[0];
    var forceRenderLayoutGroup = (0,react.useContext)(LayoutGroupContext/* LayoutGroupContext */.p).forceRender;
    if (forceRenderLayoutGroup)
        forceRender = forceRenderLayoutGroup;
    var isMounted = useIsMounted();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    var filteredChildren = onlyElements(children);
    var childrenToRender = filteredChildren;
    var exiting = new Set();
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    var presentChildren = (0,react.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    var allChildren = (0,react.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    var isInitialRender = (0,react.useRef)(true);
    (0,use_isomorphic_effect/* useIsomorphicLayoutEffect */.L)(function () {
        isInitialRender.current = false;
        updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0,use_unmount_effect/* useUnmountEffect */.z)(function () {
        isInitialRender.current = true;
        allChildren.clear();
        exiting.clear();
    });
    if (isInitialRender.current) {
        return (react.createElement(react.Fragment, null, childrenToRender.map(function (child) { return (react.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, initial: initial ? undefined : false, presenceAffectsLayout: presenceAffectsLayout }, child)); })));
    }
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(childrenToRender), false);
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    var presentKeys = presentChildren.current.map(getChildKey);
    var targetKeys = filteredChildren.map(getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    var numPresent = presentKeys.length;
    for (var i = 0; i < numPresent; i++) {
        var key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) {
            exiting.add(key);
        }
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (exitBeforeEnter && exiting.size) {
        childrenToRender = [];
    }
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach(function (key) {
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1)
            return;
        var child = allChildren.get(key);
        if (!child)
            return;
        var insertionIndex = presentKeys.indexOf(key);
        var onExit = function () {
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            var removeIndex = presentChildren.current.findIndex(function (presentChild) { return presentChild.key === key; });
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                if (isMounted.current === false)
                    return;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, react.createElement(PresenceChild, { key: getChildKey(child), isPresent: false, onExitComplete: onExit, custom: custom, presenceAffectsLayout: presenceAffectsLayout }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map(function (child) {
        var key = child.key;
        return exiting.has(key) ? (child) : (react.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, presenceAffectsLayout: presenceAffectsLayout }, child));
    });
    if (process/* env */.O !== "production" &&
        exitBeforeEnter &&
        childrenToRender.length > 1) {
        console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour.");
    }
    return (react.createElement(react.Fragment, null, exiting.size
        ? childrenToRender
        : childrenToRender.map(function (child) { return (0,react.cloneElement)(child); })));
};




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6007,6310,9122,4850,5489,453,7393,3962,9774,2888,179], function() { return __webpack_exec__(22982); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);